module.exports = __webpack_public_path__ + "static/img/one.e7b581d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/7/one.png
// module id = JhOC
// module chunks = 1